import { makeStyles, Slide, Paper, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Portal } from "@mui/material";
import { ReactNode } from "react";
import { tokens } from "../../theme/tokens";

const useStyles = makeStyles(() => ({
  backdrop: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    // Modal scrim — no scrim role exists in the token guide; matches MUI's own
    // default backdrop.
    // eslint-disable-next-line no-restricted-syntax
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1400,
  },
  drawer: {
    position: "fixed",
    bottom: 0,
    left: "16vw",
    right: "1%",
    maxHeight: "97vh",
    zIndex: 1500,
    border: `${tokens.borderWidth} solid ${tokens.color.border.default}`,
    borderBottom: "none",
    borderTopLeftRadius: tokens.radius.md,
    borderTopRightRadius: tokens.radius.md,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  header: {
    padding: tokens.space[3],
    borderBottom: `${tokens.borderWidth} solid ${tokens.color.border.default}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexShrink: 0,
  },
  content: {
    padding: tokens.space[3],
    overflowY: "auto",
    flex: 1,
  },
}));

interface BottomDrawerProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  title?: ReactNode;
  actionButton?: ReactNode;
}

const BottomDrawer: React.FC<BottomDrawerProps> = ({
  open,
  onClose,
  children,
  title,
  actionButton,
}) => {
  const classes = useStyles();

  if (!open) return null;

  return (
    <Portal>
      <div className={classes.backdrop} onClick={onClose} />
      <Slide direction="up" in={open} mountOnEnter unmountOnExit>
        <Paper className={classes.drawer} elevation={0}>
          {title && (
            <div className={classes.header}>
              <div>{title}</div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                {actionButton && <div>{actionButton}</div>}
                <IconButton size="small" onClick={onClose}>
                  <CloseIcon />
                </IconButton>
              </div>
            </div>
          )}
          <div className={classes.content}>{children}</div>
        </Paper>
      </Slide>
    </Portal>
  );
};

export default BottomDrawer;
